const Flag = ({ className }: { className?: string }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.40039 4.7999C2.40039 4.16338 2.65325 3.55293 3.10333 3.10285C3.55342 2.65276 4.16387 2.3999 4.80039 2.3999H12.8004C12.949 2.3999 13.0946 2.44127 13.221 2.51938C13.3474 2.59749 13.4495 2.70925 13.5159 2.84213C13.5824 2.97502 13.6105 3.12378 13.5972 3.27175C13.5838 3.41972 13.5295 3.56105 13.4404 3.6799L11.4004 6.3999L13.4404 9.1199C13.5295 9.23876 13.5838 9.38009 13.5972 9.52806C13.6105 9.67603 13.5824 9.82479 13.5159 9.95767C13.4495 10.0906 13.3474 10.2023 13.221 10.2804C13.0946 10.3585 12.949 10.3999 12.8004 10.3999H4.80039C4.58822 10.3999 4.38473 10.4842 4.23471 10.6342C4.08468 10.7842 4.00039 10.9877 4.00039 11.1999V13.5999C4.00039 13.8121 3.91611 14.0156 3.76608 14.1656C3.61605 14.3156 3.41256 14.3999 3.20039 14.3999C2.98822 14.3999 2.78473 14.3156 2.63471 14.1656C2.48468 14.0156 2.40039 13.8121 2.40039 13.5999V4.7999Z"
    />
  </svg>
);

export default Flag;
